import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiError } from '../api/client';
import { translateErrorCode } from '../i18n';

export function AvisoError({ error }: { error: unknown }) {
  const { t } = useTranslation();
  if (!error) return null;

  const mensaje =
    error instanceof ApiError
      ? translateErrorCode(error.code, error.params)
      : t('error.internal.error');

  return (
    <p className="aviso aviso--error" role="alert">
      {mensaje}
    </p>
  );
}

/**
 * Confirmación de una acción, **fuera del flujo del documento**.
 *
 * Estuvo insertada en la página y empujaba todo hacia abajo. Con dos
 * interruptores juntos eso es una trampa: se toca uno, aparece el aviso, la
 * página baja unos píxeles y el segundo clic cae en el interruptor de al lado.
 * Pasó de verdad —quedó en la bitácora: alguien activó la descarga sin querer—.
 * Aquí flota sobre la interfaz y no mueve nada.
 */
export function AvisoExito({ children }: { children: React.ReactNode }) {
  const [visible, setVisible] = useState(true);

  // Se retira sola: una confirmación flotante que se queda ahí acaba tapando
  // parte de la pantalla y deja de leerse como respuesta a algo.
  useEffect(() => {
    setVisible(true);
    const temporizador = window.setTimeout(() => setVisible(false), 5000);
    return () => window.clearTimeout(temporizador);
  }, [children]);

  if (!visible) return null;

  return (
    <p className="aviso aviso--exito aviso--flotante" role="status">
      {children}
    </p>
  );
}
